import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { RaisedButton, CircularProgress } from 'material-ui';
import R from 'ramda';
import moment from 'moment';
import injectSheet from 'react-jss';
import { replace as replaceAction } from 'react-router-redux';
import ReactSelect from 'react-select';

const propTypes = {
  initialBaseDocId: PropTypes.string,
  initialCompareDocId: PropTypes.string,
  collection: PropTypes.string,
  replace: PropTypes.func,
  params: PropTypes.object,
  availDocs: PropTypes.array,
  inHeader: PropTypes.bool,
  loadingDocs: PropTypes.bool,
};
const styles = {
  container: { margin: '16px auto' },
  selectionContainer: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  compareDocContainer: {
    width: '48%',
  },
  baseDocContainer: {
    width: '48%',
    marginLeft: '4%',
  },
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  }
};
class DocSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState(props);
  }
  componentWillReceiveProps(nextProps) {
    if (!(this.state.baseData && this.state.baseData.doc)) {
      this.setState(this.getInitialState(nextProps));
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  getInitialState = props => {
    const { availDocs, initialBaseDocId, initialCompareDocId, collection } = props;
    const versionsKey = collection === 'template' ? 'templateVersions' : 'versions';
    if (availDocs && availDocs.length) {
      const getDocById = id => {
        if (!id) return {};
        return availDocs.find(obj => {
          if (obj._id === id) return true;
          return obj[versionsKey] && obj[versionsKey].indexOf(id) > -1;
        });
      }
      const initialBaseDoc = getDocById(initialBaseDocId) || {};
      const initialCompareDoc = getDocById(initialCompareDocId) || {};
      const baseData = {
        docYear: this.getYearValue(initialBaseDoc),
        doc: initialBaseDoc,
        docId: initialBaseDocId,
        docVersion: initialBaseDocId === initialBaseDoc._id ? -1 : (initialBaseDoc[versionsKey] || []).findIndex(str => str === initialBaseDocId),
      };
      const compareData = initialCompareDocId ? {
        docYear: this.getYearValue(initialCompareDoc),
        doc: initialCompareDoc,
        docId: initialCompareDocId,
        docVersion: initialCompareDocId === initialCompareDoc._id ? -1 : (initialCompareDoc[versionsKey] || []).findIndex(str => str === initialCompareDocId),
      } : {};
      const data = {
        baseData,
        compareData,
      };
      return {
        initialData: data,
        ...data
      };
    }
    return {};
  };
  getYearString = (obj = {}) => {
    const dateFormat = date => moment.utc(date).format('D MMM YYYY');
    if (this.props.collection === 'contract') {
      const marketInfo = R.path(['supplierInfo', 'marketInfo'], obj);
      return `${dateFormat(obj.startDate)} - ${dateFormat(obj.endDate)}${marketInfo ? ` (${marketInfo})` : ''} `;
    }
    return `${dateFormat(obj.startDate)} - ${dateFormat(obj.endDate)}`;
  };
  getYearValue = (obj = {}) => {
    if (this.props.collection === 'contract') return obj._id;
    return this.getYearString(obj);
  };
  getDocsByYear = (yearString) => {
    return this.props.availDocs.filter(obj => this.getYearString(obj) === yearString)
  };
  update = (stateKey, obj) => {
    const _this = this;
    _this.setState({ [stateKey]: { ..._this.state[stateKey], ...obj }, updated: true });
  };
  render() {
    const { classes, replace, availDocs = [], collection, inHeader, loadingDocs } = this.props;
    if (loadingDocs) return <CircularProgress size={40} style={{ marginLeft: '50%' }} />;
    const {
      baseData = {},
      compareData = {},
    } = this.state || {};
    const sortByStartDateDsc = R.sort(R.descend(R.prop('startDate')), availDocs);
    const compareDocId = R.path(['compareData', 'docId'], this.state);
    const baseDocId = R.path(['baseData', 'docId'], this.state);
    const locationId = R.path(['baseData', 'doc', 'locationId'], this.state);
    const allContractingYears = R.uniq(sortByStartDateDsc.map(this.getYearString));
    const {
      container,
      selectionContainer,
      compareDocContainer,
      baseDocContainer,
    } = classes;
    const versionsKey = collection === 'template' ? 'templateVersions' : 'versions';
    const types = [{
      stateKey: 'compareData',
      className: compareDocContainer,
      stateData: compareData,
    }, {
      stateKey: 'baseData',
      className: baseDocContainer,
      stateData: baseData,
    }];
    const isForContract = collection === 'contract';
    return (
      <div className={container} style={{ width: inHeader ? '90%' : '80%', marginLeft: inHeader ? '1%' : 'auto', fontSize: inHeader ? '12px' : '14px' }}>
        <div className={selectionContainer}>
          {
            types.map(({ stateKey, className, stateData }, i) => {
              const {
                docYear,
                doc = {},
                docId,
                docVersion,
              } = stateData;
              return (
                <div className={className} key={i} style={{ display: isForContract ? 'flex' : 'block' }}>
                  {
                    isForContract ? (
                      <ReactSelect
                        wrapperStyle={{ width: '70%' }}
                        options={sortByStartDateDsc.map(obj => ({ value: this.getYearValue(obj), doc: obj, label: this.getYearString(obj) }))}
                        optionRenderer={option => <span>{option.label} <small>&nbsp;&nbsp;Last updated on: {moment(option.doc.updatedAt).format('l')}</small></span>}
                        value={docYear}
                        onChange={(optionItem) => {
                          this.update(stateKey, {
                            docYear: optionItem.value,
                            docId: optionItem.doc._id,
                            doc: optionItem.doc,
                            docVersion: -1,
                          })
                        }}
                        placeholder="Please select a contracting period"
                        clearable={false}
                      />
                    ) : (
                      <ReactSelect
                        wrapperStyle={{ width: '100%' }}
                        options={allContractingYears.map(str => ({ value: str, label: str }))}
                        value={docYear}
                        onChange={({ value }) => this.update(stateKey, { docYear: value, doc: {}, docId: null, docVersion: null })}
                        placeholder="Please select a contracting period"
                        clearable={false}
                      />
                    )
                  }
                  <div style={{ width: isForContract ? '30%' : '100%', display: 'flex' }}>
                    {
                      Boolean(docYear) && !isForContract && (
                        <ReactSelect
                          wrapperStyle={{ width: '65%' }}
                          options={this.getDocsByYear(docYear).map(obj => ({ value: obj.templateName, doc: obj, label: obj.templateName }))}
                          value={doc.templateName}
                          onChange={(optionItem) => {
                            this.update(stateKey, {
                              docId: optionItem.doc._id,
                              doc: optionItem.doc,
                              docVersion: -1,
                            })
                          }}
                          placeholder={`Please select a ${collection}`}
                          clearable={false}
                        />
                      )
                    }
                    {
                      Boolean(docId) && (
                        <ReactSelect
                          wrapperStyle={{ width: isForContract ? '100%' : '35%' }}
                          options={R.prepend(
                            { value: -1, label: `Version ${(doc[versionsKey] || []).length + 1} (Latest)`, versionId: doc._id },
                            R.reverse(doc[versionsKey] || []).map((versionId, i, arr) => ({ value: arr.length - i - 1, versionId, label: `Version ${arr.length - i}` }))
                          )}
                          value={docVersion}
                          onChange={({ value, versionId }) => this.update(stateKey, { docVersion: value, docId: versionId })}
                          placeholder="Version"
                          clearable={false}
                        />
                      )
                    }
                  </div>
                </div>);
            })
          }
        </div>
        {
          inHeader ? (
            <div style={{ display: this.state.updated ? 'block' : 'none', margin: '8px auto', float: 'right' }}>
              <RaisedButton
                label="Cancel"
                onTouchTap={() => this.setState({ ...this.state.initialData, updated: false })}
              />
              <RaisedButton
                label="Update"
                disabled={!(compareDocId && baseDocId)}
                style={{ marginLeft: '8px' }}
                secondary
                onTouchTap={() => {
                  this.setState({ updated: false });
                  replace(`/contracting/reports/diff/${collection}/${baseDocId}/${compareDocId}?locationId=${locationId}`);
                }}
              />
            </div>
          ) : (
            <RaisedButton
              label="Generate Diff Report"
              disabled={!(compareDocId && baseDocId)}
              style={{ marginLeft: '43%', marginTop: '24px' }}
              secondary
              onTouchTap={() => replace(`/contracting/reports/diff/${collection}/${baseDocId}/${compareDocId}?locationId=${locationId}`)}
            />
          )
        }
      </div>
    );
  }
}


const mapDispatchToProps = ({
  replace: replaceAction
});
DocSelector.propTypes = propTypes;
DocSelector.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(null, mapDispatchToProps)(injectSheet(styles)(DocSelector));




// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/diffing/doc-selector.jsx